import { DatePipe } from '@angular/common';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, buttonTypes, ComponentTypes } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { OpenBookingDTO } from 'src/app/shared/Models/OpenBookingDTO';
import { ActivityRatePlanRequest, BookingActivity, BookingBehavior } from 'src/app/shared/Models/SessionBookingDTO';
import { SlotLockIdDTO, SlotLockResultDTO } from 'src/app/shared/Models/SlotLockModels';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';

@Component({
  selector: 'app-open-booking-selector',
  templateUrl: './open-booking-selector.component.html',
  styleUrls: ['./open-booking-selector.component.scss']
})
export class OpenBookingSelectorComponent extends Utilities implements OnInit, OnDestroy {
  locationList: any[];
  bookingSizeArray: any = [];
  maxSizeAllowed: number = 60;
  SelectedActivityData: any;
  SelectedBookingData: any;
  isSessionClass: any;
  coverTypes = [];
  coverTypeConfig: FieldConfig[];
  bookingTypes = [];
  bookingTypeConfig: FieldConfig[];
  coverSizeConfig: FieldConfig[];
  membershipConfig: FieldConfig[];
  minSizeAllowed: number = 1;
  ratePlan: any;
  @ViewChild('reservationConfigForm', { static: true }) reservationConfigForm: DynamicFormComponent;
  @ViewChild('dateConfigForm', { static: true }) dateConfigForm: DynamicFormComponent;
  @ViewChild('coverTypeForm', { static: true }) coverTypeForm: DynamicFormComponent;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  CheckAvailabilityBtn: ButtonValue;
  previousButton: ButtonValue;
  nextButton: ButtonValue;
  openBookingConfig: FieldConfig[];
  Subscriptions: Subscription = new Subscription();
  displaySlots: boolean = false;
  widgetdata: any;
  availableSlots = [];
  EditData: any;
  lockResponse: any;
  hasMembershipValue: boolean = false;
  validCoverTypes: boolean = true;
  validBookingTypes: boolean = true;
  validGroupSize: boolean = true;
  isMultipleEnabled: boolean;
  membershipValid: boolean;
  membershipStatus: string;
  inputvalidation: boolean = false;
  constructor(public ts: TranslateService, public activityService: GuestService, private datePipe: DatePipe, public dialog: MatDialog, public dynamicFormService: DynamicFormService) {
    super(dialog);
    this.Subscriptions.add(this.activityService.restaurantWidgetSettings$.subscribe(data => {
      if (data) {
        this.widgetdata = data;
        if (this.widgetdata.MaxPartySize) {
          this.maxSizeAllowed = this.widgetdata.MaxPartySize;
        }
        this.coverTypes = this.widgetdata.GuestTypes;
        this.bookingTypes = this.widgetdata.BookingTypes;
      }
    }))
    this.Subscriptions.add(this.activityService.BookNew$.subscribe(data => {
      if (data) {
        if (this.components && this.activityService.operation === operationType.create) {
          this.components.forEach(x => x.form.reset());

        }
        this.activityService.BookNew$.next(false);
      }
    }));
    this.Subscriptions.add(this.activityService.editPartyData$.subscribe(data => {
      if (data && data.ReservedFor && this.activityService.bookingSection$.value === BookingActivity.OpenBooking) {
        this.EditData = data;
        this.isMultipleEnabled = this.EditData?.Slots ? true : false;
        if (this.isMultipleEnabled) {
          this.getOpenslots(this.EditData.TableIds, [], moment(this.EditData.ReservedFor).format("YYYY-MM-DD"))
        }
        this.setOpenBookingFieldConfig();
      }
    }))
    this.Subscriptions.add(this.activityService.bookingSection$.subscribe(data => {
      if (data === BookingActivity.OpenBooking) {
        this.activityService.slots_holder = [];
        this.activityService.selectedOpenBookingSlots = {};
        if (this.components && this.activityService.operation === operationType.create) {
          this.components.forEach(x => x.form.reset());
        }
      }
    }))
  }
  ngOnInit(): void {
    this.setOpenBookingFieldConfig();

  }
  ngAfterViewInit() {
    this.formChangeSubscribe();
    this.nextButton.disbaledproperity = !this.updateFormValidity();
    this.getSlots();
    // if (this.EditData && this.EditData.ReservedFor) {
    //   this.getSlotsByLocation()
    // }
  }


  getSlots() {
    this.components?.forEach(x => {
      x.form.valueChanges.subscribe(value => {
        if (value.location || value.fromDate) {
          this.getSlotsByLocation();
        }
        if (value.MembershipId) {
          this.inputvalidation = this.dynamicFormService.inputvalidation(value.MembershipId);
        }
      })
    })
  }

  isCoverTypeMatchBookingSize() {
    var coverTypeTotal = 0;

    if (!this.coverTypeConfig || !this.coverTypeConfig.length) {
      return true;
    }
    else {
      if (!this.bookingTypeConfig || !this.bookingTypeConfig.length) {
        var [, , bookingSize, covers] = this.components;
        covers.controls.forEach((control, index) => {
          coverTypeTotal += +covers.form.controls[this.coverTypes[index].Name].value;
        });
      }
      else {
        var [, , bookingSize, , covers] = this.components;
        covers.controls.forEach((control, index) => {
          coverTypeTotal += +covers.form.controls[this.coverTypes[index].Name].value;
        });
      }
    }
    if (this.getFormValue(bookingSize, "BookingSize") === '') {
      return false;
    } else {
      return +this.getFormValue(bookingSize, "BookingSize") == coverTypeTotal;
    }
  }
  isBookingTypeMatchBookingSize() {
    var [, , bookingSize, bookingTypes] = this.components;

    if (!this.bookingTypeConfig || !this.bookingTypeConfig.length) {
      return true;
    }
    var bookingTypeTotal = 0;
    bookingTypes.controls.forEach((control, index) => {
      bookingTypeTotal += +bookingTypes.form.controls[this.bookingTypes[index].Name].value;
    });
    if (this.getFormValue(bookingSize, "BookingSize") === '') {
      return false;
    } else {
      return +this.getFormValue(bookingSize, "BookingSize") == bookingTypeTotal;
    }
  }

  updateFormValidity() {
    return (this.isValidBookingSizeSelected() && this.isFormValid() && this.isBookingTypeMatchBookingSize() && this.isCoverTypeMatchBookingSize() && this.istimeSlotsSelected());
  }
  isValidBookingSizeSelected() {
    var [, , bookingSize, covers] = this.components;
    let selectedSize = +this.getFormValue(bookingSize, "BookingSize")
    if (this.widgetdata && selectedSize) {

      this.validGroupSize = true;
      this.validGroupSize = selectedSize >= 1 && selectedSize <= this.widgetdata.MaxPartySize;

      const minsize = 1;
      const maxsize = this.widgetdata.MaxPartySize;
      return this.validGroupSize;
    }
    return false;
  }
  isFormValid() {
    var isValid = true;
    this.components.forEach(componet => {
      if (!componet.form.valid && componet.form.status !== "DISABLED") {
        isValid = false;
      }
    })
    return isValid;
  }
  istimeSlotsSelected() {
    return Object.values(this.activityService.selectedOpenBookingSlots).findIndex(slot => slot) !== -1;
  }
  coverTypeConfigChange() {
    if (this.coverTypeConfig.length) {
      this.Subscriptions.add(
        this.components.last.form.valueChanges.subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
        }));
    }
  }
  bookingTypeConfigChange() {
    if (this.bookingTypeConfig.length) {
      this.Subscriptions.add(
        this.components.last.form.valueChanges.subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
        }));
    }
  }
  setOpenBookingFieldConfig() {
    this.locationList = this.activityService.LocationList;
    this.membershipConfig = [{
      type: 'input',
      label: this.ts.instant('MembershipID'),
      name: 'MembershipId',
      inputType: 'text',
      class: 'guest-details__first-name',
      showErrorText: true,
      appearance: true,
      isFormArray: false,
      validation: [],
      value: this.EditData && this.EditData.Contact.TrackMembershipNumber ? this.EditData.Contact.TrackMembershipNumber : '',
      disabled: this.EditData && this.EditData.Contact ? true : false,
      hide: this.EditData && this.EditData.Contact ? true : false
    }];
    this.openBookingConfig = [

      {
        type: 'date',
        name: 'fromDate',
        placeholder: 'select',
        appearance: true,
        isFormArray: false,
        minDate: new Date(),
        value: this.EditData ? this.EditData.ReservedFor ? this.EditData.ReservedFor : new Date() : new Date(),
        maxDate: '',
        label: this.ts.instant('SelectaDate'),
        class: "selector-date",
        validation: [Validators.required],
      },
      {
        type: 'select',
        name: 'location',
        placeholder: '',
        options: this.locationList.map(x => ({ id: x.Id, value: x.Name })),
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('SelectaLocation'),
        class: "reservation-details__party-size",
        validation: [Validators.required],
        value: this.EditData ? this.EditData.TableIds && this.EditData.TableIds.length ? this.locationList.filter(x => x.IsAvailableForReservations).map(x => x.Id).filter(x => x == this.EditData.TableIds[0])[0] : '' : ''
      },
    ]
    this.coverSizeConfig = [
      {
        type: 'autocomplete',
        name: 'BookingSize',
        placeholder: 'select',
        options: this.calculatePartySize(),
        appearance: true,
        partySize: true,
        isFormArray: false,
        class: "count",
        showErrorText: true,
        charLength: this.maxSizeAllowed.toString().length,
        validation: [Validators.required, Validators.min(1), Validators.max(this.widgetdata.MaxPartySize)],
        value: this.EditData ? this.EditData.Size : ''
      },
    ]
    this.coverTypeConfig = this.getCoverTypeConfig();
    this.coverTypeConfig = this.coverTypeConfig.map(config => {
      config.options = [{ id: 0, value: "none" }, ...this.bookingSizeArray];
      return config;
    })
    this.bookingTypeConfig = this.getBookingTypeConfig();
    this.bookingTypeConfig = this.bookingTypeConfig.map(config => {
      config.options = [{ id: 0, value: "none" }, ...this.bookingSizeArray];
      return config;
    })
    this.createActionButtons();
  }
  calculatePartySize() {
    this.bookingSizeArray = [];
    for (let i = 1; i <= this.maxSizeAllowed; i++) {
      this.bookingSizeArray.push({ id: i, value: i.toString() });
    }
    // this.bookingSizeArray.push({ id: this.maxSizeAllowed, value: this.maxSizeAllowed.toString() + "+" });

    return this.bookingSizeArray;
  }
  getSlotsByLocation() {
    var [, formdateComponent] = this.components;
    var date = moment(formdateComponent.form.get("fromDate").value).format("YYYY-MM-DD");
    if (formdateComponent.form.get("location").value && formdateComponent.form.get("fromDate").value) {
      this.activityService.selectedOpenBookingSlots = {};

      this.activityService.slots_holder = [];
      this.displaySlots = false;

      this.getOpenslots([formdateComponent.form.get("location").value], [], moment(formdateComponent.form.get("fromDate").value).format("YYYY-MM-DD"))


    }
  }

  getOpenslots(location, instructor, date) {
    this.Subscriptions.add(this.activityService.getSlotsForTable(location, instructor, date).subscribe(response => {
      this.setSlots(response);
      setTimeout(() => {
        this.activityService.slotAvailabilitySubject$.next(response);
        this.activityService.partySlots$.next(true);
      }, 100);
    }));
  }

  getEditSlots() {
    this.activityService.selectedOpenBookingSlots = {};

    this.activityService.slots_holder = [];
    this.displaySlots = false;
    if (this.EditData.TableIds && this.EditData.ReservedFor) {
      this.Subscriptions.add(this.activityService.getSlotsForTable(this.EditData.TableIds, [], this.EditData.ReservedFor.split('T')[0]).subscribe(response => {
        this.setSlots(response);
        setTimeout(() => {
          this.activityService.slotAvailabilitySubject$.next(response);
          this.activityService.partySlots$.next(true);
        }, 100);

      }));
    }
  }

  setSlots(response) {
    let SlotIds = 0;
    this.availableSlots = [];
    this.activityService.slots_holder = [];
    this.activityService.SlotIds = 0;
    this.activityService.selectedOpenBookingSlots = {}
    response.Payload.forEach(element => {
      element.OpenHours.forEach(openHour => {
        var tableId = openHour.SlotsByTableId[0].TableId;
        openHour.SlotsByTableId[0].Slots.sort((a, b) => Utilities.parseDateString(a.DateTime).getTime() - Utilities.parseDateString(b.DateTime).getTime());
        openHour.SlotsByTableId[0].Slots.forEach(slot => {
          if ((!slot.PartyId || (this.EditData && slot.PartyId && this.EditData.Id == slot.PartyId))) {
            if (slot.AllocationTypeId && this.widgetdata.AllocationMappings && this.widgetdata.AllocationMappings.length) {
              var { R, G, B, A } = this.widgetdata.AllocationMappings.filter(type => type.AllocationTypeId === slot.AllocationTypeId)[0].Color;
              slot['color'] = `rgba(${R}, ${G}, ${B}, ${A})`;
            }
            SlotIds += 1;
            slot.Id = slot.Id == 0 ? SlotIds : slot.Id;
            if (this.isNotPastTimeSlot(slot)) {
              this.activityService.slots_holder.push(slot);
            }
            let selectedSlot = null;
            if (this.EditData?.Slots) {
              selectedSlot = this.EditData.Slots.find(x => x.Time === slot.DateTime);
            }
            if (this.EditData && slot.PartyId && this.EditData.TableIds[0] == tableId && this.EditData.Id == slot.PartyId) {
              this.activityService.selectedOpenBookingSlots[slot.Id] = !this.activityService.selectedOpenBookingSlots[slot.Id];
              if (!this.EditData.Duration) {
                this.EditData.Duration = Utilities.diffBetweenDatesInMinutes(this.EditData.DepartureTime, this.EditData.SeatingTime);
              }
              if (this.EditData.Duration > this.widgetdata.TimeSlotUnitInMinutes) {

                var duration = this.EditData.Duration - this.widgetdata.TimeSlotUnitInMinutes;
                for (var i = 1; i <= duration / this.widgetdata.TimeSlotUnitInMinutes; i++) {
                  var newSlot = this.activityService.generateSlot(Utilities.Date(slot.DateTime).add(i * this.widgetdata.TimeSlotUnitInMinutes, 'minutes'));

                  newSlot.PartyId = slot.PartyId;
                  if (newSlot.Id == 0) {
                    SlotIds += 1;
                    newSlot.Id = SlotIds;
                  }
                  this.activityService.slots_holder.push(newSlot);
                  this.activityService.selectedOpenBookingSlots[newSlot.Id] = true;
                }
                // this.setBookingData();
              }
              this.checkFormValidity();
            } else if (selectedSlot) {
              this.activityService.selectedOpenBookingSlots[slot.Id] = !this.activityService.selectedOpenBookingSlots[slot.Id];
              if (selectedSlot.Duration > this.widgetdata.TimeSlotUnitInMinutes) {
                var duration = selectedSlot - this.widgetdata.TimeSlotUnitInMinutes;
                for (var i = 1; i <= duration / this.widgetdata.TimeSlotUnitInMinutes; i++) {
                  var newSlot = this.activityService.generateSlot(Utilities.Date(slot.DateTime).add(i * this.widgetdata.TimeSlotUnitInMinutes, 'minutes'));
                  newSlot.PartyId = slot.PartyId;
                  if (newSlot.Id == 0) {
                    SlotIds += 1;
                    newSlot.Id = SlotIds;
                  }
                  this.activityService.slots_holder.push(newSlot);
                  this.activityService.selectedOpenBookingSlots[newSlot.Id] = true;
                }
              }
              this.checkFormValidity();
            }
          }
        });
        var openhrSlots = openHour.SlotsByTableId[0].Slots;
        openhrSlots.forEach(slot => {
          if (this.EditData?.Slots) {
            let selectedSlot = null;
            if (this.EditData?.Slots) {
              selectedSlot = this.EditData.Slots.find(x => x.Time === slot.DateTime);
            }
            if (selectedSlot && selectedSlot.DurationInMinutes > this.widgetdata.TimeSlotUnitInMinutes) {
              var duration = selectedSlot.DurationInMinutes - this.widgetdata.TimeSlotUnitInMinutes;
              for (var i = 1; i <= duration / this.widgetdata.TimeSlotUnitInMinutes; i++) {
                var existingslot = openhrSlots.find(x => Utilities.Date(x.DateTime).isSame(Utilities.Date(slot.DateTime).add(i * this.widgetdata.TimeSlotUnitInMinutes, 'minutes')));
                this.activityService.selectedOpenBookingSlots[existingslot.Id] = true;
              }
            }
          }

        });
        this.checkFormValidity();
      });
    });

  }


  updateSelectedSlotsByMembersihps() {
    Object.entries(this.activityService.selectedOpenBookingSlots).forEach((itm => {
      if (itm[1]) {
        const allocationTypeId = this.activityService.slots_holder.find(slot_holder => slot_holder.Id == itm[0])?.AllocationTypeId;
        if (allocationTypeId && (
          !this.activityService.selectedGuest || !this.activityService.selectedGuest.MembershipType || !this.activityService.selectedGuest.MemberActive || allocationTypeId !== this.activityService.selectedGuest.MembershipType?.Id)) {
          this.activityService.selectedOpenBookingSlots[itm[0]] = false;
        }
      }

    }))
  }

  isNotPastTimeSlot(slot): boolean {
    const maxPastTime = this.widgetdata.MaxPastTimeForReservationsInMinutes;
    const currentTime = Utilities.getRestaurantDateTime(this.widgetdata.DaylightDelta);
    const past1hr = new Date(currentTime.valueOf());
    const slotTime = Utilities.parseDateString(slot.DateTime);
    return slotTime >= past1hr;
  }


  setBookingData() {
    var openBookingObj = {} as OpenBookingDTO;
    if (this.bookingTypeConfig && this.bookingTypeConfig.length) {
      var [membershipNo, formdataComponent, bookingSize, bookingTypes, covers] = this.components;
    } else {
      var [membershipNo, formdataComponent, bookingSize, covers] = this.components;
    }
    openBookingObj.MembershipDetail = membershipNo.form.get("MembershipId").value;
    openBookingObj.ToDate = formdataComponent.form.get("fromDate").value;
    openBookingObj.Location = formdataComponent.form.get("location").value;
    openBookingObj.BookingSize = bookingSize.form.get("BookingSize").value;
    this.activityService.openBookingData = new OpenBookingDTO(
      null,
      openBookingObj.ToDate,
      openBookingObj.ToDate,
      openBookingObj.Location,
      this.getLocationName(openBookingObj.Location),
      openBookingObj.BookingSize,
      openBookingObj.MembershipDetail,
      this.getCoverTypeValues(covers),
      this.getBookingTypeValues(bookingTypes),
      this.getSlotsObj()
    );
  }
  getLocationName(locationId) {
    return this.locationList.filter(location => location.Id === locationId)[0].Name;
  }

  createActionButtons() {

    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('next'),
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
  }



  gotoNextPage(event) {
    if (this.activityService.selectedGuest && this.activityService.selectedGuest.TrackMembershipNumber && !this.activityService.selectedGuest?.MemberActive) {
      const popUpMessage = [{
        confirmationMessage: this.ts.instant('memberShipExpired'),
        dialogTitle: this.ts.instant('memberShipStatus'),
        showAlert: true
      }];
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', 'static', popUpMessage,
        popUpMessage[0].dialogTitle);
      const confirm = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '250px', false, 'No', 'ok',
        'ok', false)
      return;
    }
    this.setBookingData();
    this.lockTables();
  }


  lockTables() {
    var { Slots, GuestTypes, BookingTypes, Location, BookingSize } = this.activityService.openBookingData;
    var slots = Slots.map(slot => {
      return {
        "LocalTime": slot.LocalTime,
        "PartySize": BookingSize,
        "SeatingAreaId": null,
        "SeatingTypeId": null,
        "IsCommunalTable": false,
        "FromWebsite": true,
        "DurationInMinutes": slot.Duration,
        "lockIdToIgnore": slot.LockId || null,
        "TableIds": [Location],
        "ReservationIdToIgnore": slot.PartyId
      }
    });
    if (slots.length) {
      this.Subscriptions.add(this.activityService.lockTables(slots).subscribe(response => {
        this.lockResponse = response.Payload;
        this.activityService.lockMultipleResult = {};
        this.createSaveRequestObj();
        let lockData: any = Object.values(this.lockResponse);
        let lockKeys: any = Object.keys(this.lockResponse);
        let slotAvailablity = true;
        let msg = '';
        lockKeys.forEach((data, index) => {
          if (!this.lockResponse[data].SlotLockIdDTO?.Id) {
            slotAvailablity = false;
            msg = msg + this.datePipe.transform(data, 'hh:mm a');
            if (index !== lockKeys.length) {
              msg = msg + ', '
            }
          } else {
            let obj = {} as SlotLockResultDTO
            obj[data] = this.lockResponse[data];
            this.activityService.lockMultipleResult[data] = this.lockResponse[data];
          }
        });
        if (!slotAvailablity) {
          this.activityService.setMessageState(this.ts.instant('SlotIsNotFound') + ' for ' + msg, 0);
        } else {
          this.activityService.lockMultipleIds = Object.values(this.activityService.lockMultipleResult).map((x: SlotLockResultDTO) => x?.SlotLockIdDTO?.Id)
          if (!this.activityService.restaurantWidgetSettings$.value.IsCartEnabled || this.activityService.operation !== operationType.create) {
            let timer = moment(lockData[0].ExpiresAt).diff(moment(lockData[0].LockedAt), "seconds");
            this.activityService.showTimer = true;
            this.activityService.runTimer(timer);
          }
          if (this.activityService.operation == operationType.edit) {
            this.setRatePlanCalculation(Slots, GuestTypes, BookingTypes, Location, BookingSize);
            this.activityService.additionalGuestPage = false;
          } else {
            this.activityService.TabChange$.next(ActivityTabs.ReservationDetails);
          }
        }
      }));
    }

  }

  setRatePlanCalculation(Slots, GuestTypes, BookingTypes, Location, BookingSize, Payload?) {
    this.lockResponse = Payload;
    var request = {
      Slots: Slots,
      ActivityId: null,
      GuestTypes,
      BookingTypes,
      TableIds: [Location],
      Size: +BookingSize,
      SessionSlot: null,
      TrackMembershipNumber: this.activityService.selectedGuest && this.activityService.selectedGuest.TrackMembershipNumber,
      MemberType: this.activityService.selectedGuest?.MembershipType?.AllocationName,
      IsMemberActive: this.activityService.selectedGuest?.MemberActive,
      BookingBehavior: BookingBehavior.OpenBooking
    } as ActivityRatePlanRequest;
    this.Subscriptions.add(this.activityService.GetSessionRatePlanCalculated(request).subscribe(response => {
      this.ratePlan = response.Payload;
      if (this.ratePlan && this.ratePlan.TotalRatePlan && this.ratePlan.RatePlanCalculations) {
        this.ratePlan.SlotList = this.ratePlan.RatePlanCalculations.map(slot => {
          slot.coverTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.GuestTypeVariant ? slot.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
            coverVariant.CoverTypeName = this.coverTypes.find(coverType => coverType.Id == coverVariant.CoverTypeId).Name;
            return coverVariant;
          }).filter(coverVariant => coverVariant.Variant) : [];
          slot.bookingTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.BookingTypeVariant ? slot.RatePlanVariants.BookingTypeVariant.map(bookingTypeVariant => {
            bookingTypeVariant.BookingTypeName = this.bookingTypes.find(bookingType => bookingType.Id == bookingTypeVariant.BookingTypeId).Name;
            return bookingTypeVariant;
          }).filter(bookingTypeVariant => bookingTypeVariant.Variant) : [];
          return slot;
        });

      } else {
        this.ratePlan.SlotList = Slots;
      }
      if (this.ratePlan.TotalRatePlan || this.ratePlan.RatePlanCalculations) {
        this.activityService.RatePlanList$.next(this.ratePlan);
      }
      this.createSaveRequestObj();
      this.activityService.TabChange$.next(ActivityTabs.ReservationDetails);
    }));
  }

  createSaveRequestObj() {
    const bookingData = this.activityService.openBookingData;
    this.activityService.SaveBookingObj = {
      "Id": null,
      "Size": bookingData.BookingSize,
      "RemindAboutVisit": false,
      "RemindAboutVisitEmail": false,
      "AgreedWithTermsOfUse": true,
      "Contact": {},
      "OpenTimeSlots": bookingData.Slots,
      "Slots": this.getRequestObjectSlots(),
      "PartyId": null,
      "SeatingAreaId": null,
      "SeatingTypeId": null,
      "Notes": [],
      "TableIds": [bookingData.Location],
      "CoverTypes": bookingData.GuestTypes,
      "CoverTypeQuantities": bookingData.GuestTypes,
      "BookingTypeQuantities": bookingData.BookingTypes,
      "BookingTypes": bookingData.BookingTypes,
      "IsCommunalTable": false,
      "FromWebsite": true,
      "Language": 0,
      "ReservationAttemptId": null,
      "waiverFormTransactionId": null,
      "SecondaryContactsList": null,
      "StartDate": new Date(bookingData.FromDate).toDateString(),//(moment(bookingData.FromDate).format()).split("+")[0],
      "EndDate": new Date(bookingData.ToDate).toDateString(),// (moment(bookingData.ToDate).format()).split("+")[0],
      "RatePlanTimeSlots": this.getRatePlanSlots(bookingData.Slots)
    }
  }

  getRatePlanSlots(timeslots) {
    return timeslots.map((slot) => {
      return {
        LocalTime: slot.LocalTime,
        Duration: slot.Duration,
        ReservationAttemptId: null
      }
    })
  }
  getFormValue(formObj, fieldName) {
    if (!formObj) {
      return formObj;
    }
    return formObj.form.get(fieldName)?.value;
  }

  getCoverTypeValues(covers) {
    return this.coverTypes.map(coverType => {
      return { covers: this.getFormValue(covers, coverType.Name), CoverTypeId: coverType.Id, Name: coverType.Name, Covers: this.getFormValue(covers, coverType.Name) }
    })
  }

  getBookingTypeValues(bookingTypes) {
    return this.bookingTypes.map(bookingType => {
      return { BookingTypes: this.getFormValue(bookingTypes, bookingType.Name), BookingTypeId: bookingType.Id, Name: bookingType.Name }
    })
  }

  getSlotsObj() {
    let { selectedOpenBookingSlots, slots_holder } = this.activityService
    let resSlots = [];
    let slots = Object.entries(selectedOpenBookingSlots)
      .filter(arr => arr[1]);
    for (let slotI = 0; slotI < slots.length; slotI++) {
      let itm = slots[slotI];
      let currentSlotIndex = slots_holder.findIndex(slot_holder => slot_holder.Id == itm[0]);
      if (currentSlotIndex >= 0) {
        var slot = slots_holder[currentSlotIndex];
        // if (slot.PartyId && slot.PartyId && this.EditData.ReservedFor != slot.DateTime) {
        //   continue;
        // }
        var resSlot = {
          LocalTime: slot.DateTime,
          Duration: this.widgetdata.TimeSlotUnitInMinutes,
          EndTime: this.calculateEndTime(slots_holder[currentSlotIndex].DateTime, this.widgetdata.TimeSlotUnitInMinutes),
          PartyId: (slot.PartyId && this.activityService.editPartyData$.value.Id) ? slot.PartyId : null,
          LockId: (this.lockResponse) ? this.lockResponse[slot.DateTime]?.SlotLockIdDTO?.Id : null,
        }

        for (let i = (currentSlotIndex + 1); slots_holder[i]; i++) {
          let slotDateTime = new Date(slots_holder[i].DateTime);
          let defaultDateTime = new Date(slots_holder[currentSlotIndex].DateTime);
          let mins: any = (slotDateTime.getTime() - defaultDateTime.getTime()) / (60 * 1000);
          if (slots.find(slot => slot[1] && +slot[0] == slots_holder[i].Id && mins <= resSlot.Duration)) {
            resSlot.Duration += this.widgetdata.TimeSlotUnitInMinutes;
            slotI += 1;
          } else {
            break;
          }
        }
        resSlot.EndTime = this.calculateEndTime(resSlot.LocalTime, resSlot.Duration)
        resSlots.push(resSlot);
      }
    }

    return resSlots;
  }


  calculateEndTime(startTimeStr, duration) {
    var startTime = new Date(startTimeStr);
    var startMins = startTime.getMinutes();
    startTime.setMinutes(startMins + duration);
    return startTime;
  }

  getRequestObjectSlots() {
    var bookingData = this.activityService.openBookingData;

    return bookingData.Slots.map((slot, index) => {
      return {
        Time: slot.LocalTime,
        LockId: (this.lockResponse) ? this.lockResponse[slot.LocalTime]?.SlotLockIdDTO?.Id : null,
        Type: 4,
        DurationInMinutes: slot.Duration
      }
    })
  }

  checkFormValidity() {
    this.nextButton.disbaledproperity = !this.updateFormValidity();
  }
  formChangeSubscribe() {
    this.components.forEach((x, index) => {
      this.Subscriptions.add(x.form?.valueChanges.pipe(debounceTime(100),
        distinctUntilChanged()).subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          if (value.BookingSize) {
            this.activityService.additionalGuestLength = value.BookingSize;
          }
          if (value.MembershipId ||
            (this.activityService.selectedGuest?.MembershipType && (value.MembershipId == ""))) {
            this.hasMembershipValue = value.MembershipId.length > 0;
            this.activityService.selectedGuest = null;
            this.updateSelectedSlotsByMembersihps();
            // this.partyService.selectedMembershipDetail$.next(false);
            if (value.MembershipId.length == 16) {
              this.CheckMemberShip(value.MembershipId, null);
            }
          }
          this.updateSelectedSlotsByMembersihps();
          this.validCoverTypes = this.isCoverTypeMatchBookingSize();
          this.validBookingTypes = this.isBookingTypeMatchBookingSize();
        })
      )
    });
  }


  CheckMemberShip(membershipId, editContactData) {
    this.Subscriptions.add(this.activityService.getContactFromEngagebyCardno(membershipId).subscribe(response => {
      if (response.Payload) {
        const memberShipdetail = response.Payload;
        let editPartyData = {
          Id: this.EditData && this.EditData.Id !== null ? this.EditData.Id : null,
          Contact: {},
        };
        if (this.hasMembershipValue && response.Payload && response.Payload.MembershipType) {
          this.membershipValid = true;
        } else {
          this.membershipValid = false;
        }
        const memberType = this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(allocation => allocation.AllocationTypeName.trim().toLocaleLowerCase() === memberShipdetail.MembershipType.trim().toLocaleLowerCase());
        const guestObject = {
          FirstName: memberShipdetail.FName,
          LastName: memberShipdetail.LName,
          EmailAddress: memberShipdetail.Email,
          PhoneNumber: memberShipdetail.PhoneNumber,
          CountryId: this.activityService.getCountryId(memberShipdetail.PhoneCode),
          PIILastUsedDate: null,
          EmailAddress2: memberShipdetail.EmailList && memberShipdetail.EmailList.length > 1 ? memberShipdetail.EmailList[1]?.EmailId : null,
          PhoneNumber2: memberShipdetail.PhoneList && memberShipdetail.PhoneList.length > 1 ? memberShipdetail.PhoneList[1]?.PhoneNumber : memberShipdetail.PhoneNumber,
          Birthday: memberShipdetail.Dob,
          ContactCustomFields: [],
          Notes: [],
          VisitStats: [],
          MarketingOptedIn: null,
          memberShipId: memberShipdetail.CardNo,
          MembershipType: memberShipdetail.MembershipType,
          MemberActive: memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        this.membershipStatus = memberShipdetail.MembershipStatus;
        editPartyData.Contact = guestObject;
        this.activityService.editPartyData$.next(editPartyData);
        if (editContactData) {
          editContactData.memberShipId = memberShipdetail.CardNo,
            editContactData.MembershipType = memberType,
            editContactData.MemberActive = memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        this.activityService.selectedGuest = editContactData ? editContactData : guestObject;
        this.activityService.selectedGuest.TrackMembershipNumber = memberShipdetail.CardNo; // to bind it in the guest form
        this.activityService.membershipId = this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(x => x.AllocationTypeName.trim().toLowerCase() == response.Payload.MembershipType.trim().toLowerCase())?.AllocationTypeId;
      }
    }))
  }
  getFormComponent(...args) {
    return args.map(arg => this.components.find(form => form && form.form ? form.form?.value[arg] : form?.value[arg]))
  }
  getCoverTypeConfig(): FieldConfig[] {
    return this.coverTypes.map(coverType => {
      return {
        type: 'select',
        label: coverType.Name,
        name: coverType.Name,
        value: (this.EditData && this.EditData.CoverTypeQuantities && this.EditData.CoverTypeQuantities.filter(ct => ct.CoverTypeId == coverType.Id && ct.Covers > 0).length > 0) ? this.bookingSizeArray[this.EditData.CoverTypeQuantities.filter(ct => ct.CoverTypeId == coverType.Id)[0].Covers - 1].id : 0,
        options: this.bookingSizeArray,
        class: 'activity-instructor',
        appearance: true,
        isFormArray: false,
      } as FieldConfig;
    })
  }
  getBookingTypeConfig(): FieldConfig[] {
    return this.bookingTypes.map(bookingType => {
      return {
        type: 'select',
        label: bookingType.Name,
        name: bookingType.Name,
        value: (this.EditData && this.EditData.BookingTypeQuantities && this.EditData.BookingTypeQuantities.filter(bt => bt.BookingTypeId == bookingType.Id && bt.BookingTypes > 0).length > 0) ? this.bookingSizeArray[this.EditData.BookingTypeQuantities.filter(bt => bt.BookingTypeId == bookingType.Id)[0].BookingTypes - 1].id : 0,
        options: this.bookingSizeArray,
        class: 'activity-instructor',
        appearance: true,
        isFormArray: false,
      } as FieldConfig;
    })
  }
  setCoverTypeValue(covertType) {
    this.widgetdata?.GuestTypes?.forEach(data => {
      if (data.CoverTypeId === covertType.Id) {
        return data.covers;
      }
    });
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }
}


